import { createContext, useContext } from 'react';

export interface LiveDemoContextType {
  isLiveDemoEnabled: boolean;
  setLiveDemoEnabled: (enabled: boolean) => void;
  toggleLiveDemo: () => void;
}

export const LiveDemoContext = createContext<LiveDemoContextType | undefined>(undefined);

export function useLiveDemoContext() {
  const context = useContext(LiveDemoContext);
  if (context === undefined) {
    throw new Error('useLiveDemoContext must be used within a LiveDemoProvider');
  }
  return context;
}
